import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAT5mo75I8I9CfXRn-ibFwijvdah6VXfCE",
  authDomain: "purejar-store.firebaseapp.com",
  projectId: "purejar-store",
  storageBucket: "purejar-store.firebasestorage.app",
  messagingSenderId: "508216160778",
  appId: "1:508216160778:web:31ec6f7eb836947f0e25f3",
  measurementId: "G-W6VC3LHNTG"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
